import React from 'react'
import { withIcon } from '../../withIcon'

function AirplayOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 22">
      <path d="M11.7314 12.6738C11.8577 12.5334 12.0788 12.5334 12.2051 12.6738L16.0801 16.9971C16.2643 17.2022 16.1188 17.5283 15.8428 17.5283H8.09375C7.81849 17.5283 7.67318 17.2022 7.85742 16.9971L11.7314 12.6738ZM20.6729 4C21.072 4.00003 21.3954 4.32355 21.3955 4.72266V14.3633C21.3954 14.7624 21.072 15.0859 20.6729 15.0859H15.8301C15.431 15.0859 15.1075 14.7624 15.1074 14.3633C15.1074 13.9641 15.4309 13.6407 15.8301 13.6406H19.9502V5.44531H4.0498V13.6406H8.13477C8.53383 13.6408 8.85742 13.9642 8.85742 14.3633C8.85734 14.7623 8.53377 15.0858 8.13477 15.0859H3.32715C2.92808 15.0859 2.60458 14.7624 2.60449 14.3633V4.72266C2.60456 4.32357 2.92807 4.00007 3.32715 4H20.6729Z" fill={color}/>
    </svg>
  )
}

export default withIcon(AirplayOutlineIcon)
